
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, AlertTriangle } from "lucide-react";
import { Logo } from "@/components/Logo";
import { useState } from "react";

const Index = () => {
  const navigate = useNavigate();
  const [isProcessing, setIsProcessing] = useState(false);

  const handleStartOnboarding = () => {
    setIsProcessing(true);
    // Navigate directly to the onboarding page
    navigate("/onboarding");
    setIsProcessing(false);
  };

  return (
    <div className="min-h-screen flex flex-col">
      <header className="py-4 px-4 border-b">
        <div className="container max-w-lg mx-auto">
          <Logo size="md" showText={true} />
        </div>
      </header>
      
      <main className="flex-1 flex items-center justify-center p-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="max-w-sm w-full mx-auto text-center space-y-6"
        >
          <motion.div 
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ delay: 0.2, duration: 0.5 }}
            className="mx-auto"
          >
            <h1 className="text-2xl md:text-3xl font-bold tracking-tight mb-2">
              Welcome to Cray Cray Reposters
            </h1>
            <p className="text-base text-gray-600 mb-6">
              The #1 communication app for couples
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.5 }}
            className="bg-white p-5 rounded-xl shadow-sm border border-gray-100"
          >
            <h2 className="text-lg font-semibold mb-3">Reposter Onboarding</h2>
            <p className="text-gray-600 mb-5 text-sm">
              This guided process will help you create and warm up your TikTok account to become an official Cray Cray content reposter.
            </p>
            <Button 
              className="w-full group" 
              onClick={handleStartOnboarding}
              disabled={isProcessing}
            >
              {isProcessing ? "Loading..." : "Start Onboarding"}
              <ArrowRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
            </Button>
            
            <div className="mt-4 flex items-start gap-2 text-amber-700 bg-amber-50 p-3 rounded-md text-sm">
              <AlertTriangle className="h-4 w-4 flex-shrink-0 mt-0.5" />
              <p className="text-left text-xs">
                Important: Only proceed after we've started a contract on Upwork. You'll need this contract number during the process.
              </p>
            </div>
          </motion.div>
        </motion.div>
      </main>
    </div>
  );
}

export default Index;
